import { render, staticRenderFns } from "./channelItem.vue?vue&type=template&id=424b021e&scoped=true"
import script from "./channelItem.vue?vue&type=script&lang=js"
export * from "./channelItem.vue?vue&type=script&lang=js"
import style0 from "./channelItem.vue?vue&type=style&index=0&id=424b021e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b021e",
  null
  
)

export default component.exports